










































































import {
  Component,
  Prop,
  Vue,
  Watch,
} from 'vue-property-decorator';
import SearchSuggest from '@/models/SearchSuggest';
import ValidateSearchTerm from '@/rules/ValidateSearchTerm';
import { BaseAction, FilterAction, SearchAction } from '@/store/actions';
import {
  BaseGetter, SearchGetter, FilterGetter,
} from '@/store/getters';
import OriginalSearch from '@/models/OriginalSearch';
import FilterOption from '@/models/FilterOption';

@Component({
  name: 'search-input-component',
})
export default class SearchInputComponent extends Vue {
  @Prop({ default: ValidateSearchTerm.SPECIAL_CHARS })
  private specialChars: string | undefined;

  private localSearchTerm = this.storeSearchTerm;

  private searchTermChanged = false;

  get isLoading(): boolean {
    return this.$store.getters[SearchGetter.IsLoading];
  }

  get searchSuggestions(): SearchSuggest {
    return this.$store.getters[SearchGetter.SearchSuggestions];
  }

  get searchOriginal(): OriginalSearch {
    return this.$store.getters[SearchGetter.OriginalSearch];
  }

  get storeSearchTerm(): string {
    return this.$store.getters[SearchGetter.SearchTerm];
  }

  get isValid(): boolean {
    return this.isNotShort;
  }

  get isNotShort(): boolean {
    return this.localSearchTerm.length >= 2;
  }

  private get errors(): Map<string, string> {
    return this.$store.getters[BaseGetter.Errors];
  }

  private get hasErrors(): boolean {
    return this.errors.size > 0;
  }

  private get warnings(): Map<string, string> {
    return this.$store.getters[BaseGetter.Warnings];
  }

  private get hasWarnings(): boolean {
    return this.warnings.size > 0;
  }

  private get appliedFilterOptions(): Map<string, FilterOption> {
    return this.$store.getters[FilterGetter.AppliedFilterOptions];
  }

  @Watch('storeSearchTerm')
  storeSearchTermChanged(newValue: string) {
    this.localSearchTerm = newValue;
    this.searchTermChanged = true;
  }

  private scrollTopDelayed(): Promise<void> {
    return new Promise((resolve) => {
      const el: Element = this.$refs?.searchInputComponent as Element;
      this.$nextTick(async () => {
        await ((ms: number) => new Promise((r) => setTimeout(r, ms))).call(null, 1000);
        if (el.getBoundingClientRect().top < 0) {
          el.scrollIntoView(false);
        }
        this.searchTermChanged = false;
        resolve();
      });
    });
  }

  @Watch('isLoading')
  scrollTop(isLoading: boolean) {
    if (!isLoading && this.searchTermChanged) {
      this.scrollTopDelayed();
    }
  }

  private async submitForm(event: Event): Promise<void> {
    event.preventDefault();
    if (this.isValid && this.localSearchTerm !== this.storeSearchTerm) {
      if (this.appliedFilterOptions.size > 0) {
        await this.$store.dispatch(FilterAction.RemoveAllAppliedFilterOptions);
      }
      await this.$store.dispatch(SearchAction.SearchWithNewTerm, {
        searchTerm: this.localSearchTerm,
      });
    }
  }

  private triggerSuggestedSearch() {
    this.$store.dispatch(SearchAction.SearchWithNewTerm, {
      searchTerm: this.searchSuggestions.term,
    });
  }

  private async triggerOriginalSearch() {
    await this.$store.dispatch(SearchAction.SetStrictSearch, 1);

    await this.$store.dispatch(SearchAction.SearchWithNewTerm, {
      searchTerm: this.searchOriginal.term,
    });

    await this.$store.dispatch(SearchAction.SetStrictSearch, 0);
  }

  private preventTypingSpecialCharacters(event: KeyboardEvent) {
    if (this.specialChars && this.specialChars.indexOf(event.key) > -1) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }

  // when input value changed
  private checkAndRemoveSpecialCharacters() {
    this.localSearchTerm = ValidateSearchTerm.validate(this.localSearchTerm);
  }

  private hideErrors(event: Event): void {
    event.preventDefault();
    this.$store.dispatch(BaseAction.ClearErrors);
  }

  private hideWarnings(event: Event): void {
    event.preventDefault();
    this.$store.dispatch(BaseAction.ClearWarnings);
  }
}
